<div class="container-dump-point">
    <div #scroll (scroll)="onScroll()" [ngStyle]="{ overflowX: 'auto' }">
        <table
            aria-label="tabla-punto-vaciado"
            class="mt-table mt-table-striped"
            [ngClass]="{
                'shadow-bottom': !disableShadowBottom,
                'shadow-top': !disableShadowTop,
                'shadow-top-bottom': !disableShadowTopBottom
            }"
            [style.width.px]="widthScrollContainer"
        >
            <thead>
                <tr>
                    <th class="empty shadow"></th>
                    <th
                        *ngFor="let machine of machineNames"
                        class="header"
                        [attr.colspan]="machine.length"
                    >
                        {{ "shift_" | lang }} {{ machine[0].shift }}
                    </th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td class="header-empty shadow"></td>
                    <ng-container *ngFor="let machine of machineNames">
                        <td
                            *ngFor="let m of machine; index as i"
                            class="header-bold"
                            [ngClass]="{
                                'header-empty': i + 1 === machine.length
                            }"
                        >
                            {{ m.machine }}
                        </td>
                    </ng-container>
                    <td class="header-bold shadow">
                        {{ "total" | lang | uppercase }}
                    </td>
                </tr>
                <tr *ngFor="let dumpPoint of dumpPointMapped">
                    <td class="header-empty shadow">{{ dumpPoint[0] }}</td>
                    <ng-container
                        *ngFor="let point of dumpPoint[1]; index as idx"
                    >
                        <td
                            *ngFor="let data of point; index as idx"
                            [ngClass]="{
                                'header-empty': idx + 1 === point.length
                            }"
                        >
                            {{ data }}
                        </td>
                    </ng-container>
                    <td class="header-bold shadow">{{ dumpPoint[2] }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
